export default {"src":"/_next/static/media/avweth.b908d7ce.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};